module.exports = __webpack_public_path__ + "img/MAP.3f0da463.webp";